import { useLazyQuery, useMutation } from "@apollo/client";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import { IconButton, Typography, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {
  createBlog,
  fetchBlogById,
  fetchBlogs,
  updateBlog as updateBlogMutation,
} from "@platformx/authoring-apis";
import {
  AUTH_INFO as authInfo,
  buildCDNURL,
  ShowToastError as showToastError,
  ShowToastSuccess,
  useUserSession,
} from "@platformx/utilities";
import { memo, SyntheticEvent, useEffect, useState } from "react";
import ReactDomServer from "react-dom/server";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { timeLineBlogsConstDesign } from "./blogCss";
import BlogEvents from "./BlogEvents/BlogEvents";
import BlogHeaderTabMobileView from "./BlogHeaderFooderTab/BlogHeaderTabMobileView";
import Blogs from "./Blogs/Blogs";
import ContentTypeCard from "./Blogs/ContentTypeCard";
import BlogTimeline from "./BlogTimeline/BlogTimeline";
import "./TimeLineBlogs.css";
import { defaultFallBackImage, updatedBlogToSend } from "./Utils/helperBlogs";

const styles = timeLineBlogsConstDesign();

const assetArrayMake = (selectedImage, selectedVideo) => {
  let newArray: any[] = [];
  if (Object.values(selectedImage)?.length > 0) {
    newArray = [...newArray, selectedImage];
  }

  if (Object.values(selectedVideo)?.length > 0) {
    newArray = [...newArray, selectedVideo];
  }
  return newArray;
};

const removeHTML = (str) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = str;
  const divToRemove = tempDiv.querySelectorAll(".removeContentDescription");
  if (divToRemove.length > 0) {
    divToRemove.forEach((item) => item.remove());
  }
  return tempDiv.innerHTML;
};

/** Escapes a string for safe use inside HTML attribute values delimited by double-quotes. */
const escapeAttr = (value: string): string =>
  value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

const assetDescMake = (selectedImage, selectedVideo, contentHtml = "") => {
  const thumbnailImage = buildCDNURL(selectedImage?.Thumbnail);
  let newDesc = "";
  if (Object.values(selectedImage)?.length > 0) {
    const imgHtml = `<div class='removeContentDescription'><img src='${thumbnailImage}' class='blogImage' style='border-radius: 8px; display:block; object-fit:cover'/></br></div>`;
    newDesc = newDesc + " " + imgHtml;
  }

  if (Object.values(selectedVideo)?.length > 0) {
    let vidHtml: string;
    if (selectedVideo.videoId) {
      const thumbnailUrl = escapeAttr(buildCDNURL(selectedVideo.Thumbnail) || "");
      const videoUrl = escapeAttr(selectedVideo.Url || "");
      const videoId = escapeAttr(selectedVideo.videoId);
      vidHtml = `<div class='removeContentDescription'><div class="brightcove-embed descAsset" data-brightcove-id="${videoId}" data-thumbnail="${thumbnailUrl}" data-video-url="${videoUrl}"></div></div>`;
    } else {
      vidHtml = `<div class='removeContentDescription'><video class='blogVideo' controls playsinline style="border-radius: 8px; object-fit: cover; display: block" poster='${buildCDNURL(selectedVideo.Thumbnail)}' 
  disablepictureinpicture controlslist="nodownload noplaybackrate">
        <source src='${selectedVideo.Url}' type="video/mp4" /></video></br></div>`;
    }
    newDesc = newDesc + " " + vidHtml;
  }
  if (contentHtml) {
    newDesc = `${newDesc} <div class='removeContentDescription'>${contentHtml}</div>`;
  }

  return newDesc;
};

const TimeLineBlogs = () => {
  const navigate = useNavigate();
  const [galleryState, setGalleryState] = useState<boolean>(false);
  const theme = useTheme();
  const noWeb = useMediaQuery(theme.breakpoints.down("sm"));

  const rows = 20;
  const { t } = useTranslation();
  const [getSession] = useUserSession();
  const { userInfo = {} } = getSession() || {};

  const username = `${userInfo.first_name} ${userInfo.last_name}`;
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const eventPath = urlParams.get("path") || "";

  const [fetchBlogsQuery] = useLazyQuery(fetchBlogs);
  const [fetchBlogByIdQuery] = useLazyQuery(fetchBlogById);
  const [createBlogMutate] = useMutation(createBlog);
  const [updateBlogMutate] = useMutation(updateBlogMutation);

  const [apiCountCall, setApiCountCall] = useState(0);
  const [selectedTabvalue, setValue] = useState("1");
  const [savedBlogId, setSavedBlogId] = useState("");
  const [savedBlogData, setSavedBlogData] = useState<any>();
  const [isBlogLoad, setIsBlogLoad] = useState<boolean>(false);
  const [isBlogCreate, setIsBlogCreate] = useState<boolean>(false);
  const [isStarOpen, setIsStarOpen] = useState(false);
  const [isCodeOpen, setIsCodeOpen] = useState(false);
  const [isQuoteOpen, setIsQuoteOpen] = useState(false);
  const [isLinkOpen, setIsLinkOpen] = useState(false);

  const [contentTypeData, setContentTypeData] = useState<any>({});
  const { contentHtml = "", contentItem = {} } = contentTypeData;
  const [publishButton, setPublishButton] = useState(false);
  const [blogData, setBlogData] = useState<any>({
    BlogTitle: "",
    BlogEmbed: "",
    BlogTextArea: "",
    BlogAuthorName: "",
    BlogKeyHighlighter: "",
    BlogTimeStamp: null,
    cta_url: "",
    cta_title: "",
  });

  const [selectedImage, setSelectedImage] = useState({});
  const [selectedVideo, setSelectedVideo] = useState({});

  const commonBlogDataDefault = () => {
    const newObj = {
      BlogTitle: "",
      BlogEmbed: "",
      BlogTextArea: "",
      BlogAuthorName: "",
      BlogKeyHighlighter: "",
      BlogTimeStamp: null,
      cta_url: "",
      cta_title: "",
    };
    setBlogData(newObj);
  };

  const handleTabChange = (_event: SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const starClickHandel = () => {
    setIsStarOpen(!isStarOpen);
    commonBlogDataDefault();
    setIsLinkOpen(false);
    if (isQuoteOpen) {
      setIsQuoteOpen(false);
    }
  };

  const quoteClickHandel = () => {
    setIsQuoteOpen(!isQuoteOpen);
    commonBlogDataDefault();
    setIsLinkOpen(false);
    if (isStarOpen) {
      setIsStarOpen(false);
    }
  };

  const linkClickHandle = () => {
    setIsLinkOpen(!isLinkOpen);
    commonBlogDataDefault();
    setIsQuoteOpen(false);
    setIsStarOpen(false);
  };

  // Update blog data while typing
  const handleBlogChange = (event: any = {}) => {
    const { target: { name = "", value = "" } = {} } = event;
    switch (name) {
      case "BlogTitle":
        setBlogData({ ...blogData, [name]: value });
        break;
      case "BlogTextArea":
        setBlogData({ ...blogData, [name]: value });
        break;
      case "BlogEmbed":
        setBlogData({ ...blogData, [name]: value });
        break;
      case "BlogKeyHighlighter":
        setBlogData({ ...blogData, [name]: value });
        break;
      case "BlogAuthorName":
        setBlogData({ ...blogData, [name]: value });
        break;
      case "BlogTimeStamp":
        setBlogData({ ...blogData, [name]: value });
        break;
      case "cta_url":
        setBlogData({ ...blogData, [name]: value });
        break;
      case "cta_title":
        setBlogData({ ...blogData, [name]: value });
        break;
      default:
        break;
    }
  };

  const onRemoveImage = () => {
    ShowToastSuccess("Image removed.");
    setSelectedImage({});
  };

  const onRemoveVideo = () => {
    ShowToastSuccess("Video removed.");
    setSelectedVideo({});
  };

  /**\
   * after success empty media types
   */
  const setImageOrVideoToDefault = () => {
    setSelectedImage({});
    setSelectedVideo({});
    setContentTypeData({});
  };

  /**\
   * content type
   */
  const onRemoveContentType = () => {
    ShowToastSuccess("Content removed.");
    setContentTypeData({});
  };

  const handleSelectedVideo = (video, showToast) => {
    if (!showToast) {
      ShowToastSuccess("Video added.");
    }
    setSelectedVideo({ ...video, media: "video" });
  };

  const handleSelectedImage = (image, showToast) => {
    if (!showToast) {
      ShowToastSuccess("Image added.");
    }
    setSelectedImage({ ...image, media: "image" });
    setGalleryState(false);
  };

  const handleContentType = (contentEvent) => {
    setContentTypeData(contentEvent);
  };

  /**
   * save and edit have common func
   * @param resArray array
   */
  const commonSaveData = (resArray: any = []) => {
    const savedCustomerData = {
      BlogTitle: resArray?.[0]?.title,
      BlogAuthorName: resArray?.[0]?.authors[0],
      BlogEmbed: resArray?.[0]?.embeded[0]?.code,
      BlogTimeStamp: resArray?.[0]?.key_highlighter[0]?.time,
      BlogKeyHighlighter: resArray?.[0]?.key_highlighter[0]?.highlighter,
      BlogTextArea: removeHTML(resArray?.[0]?.description)?.replaceAll("\n", ""),
      cta_url: resArray?.[0]?.cta_url || "",
      cta_title: resArray?.[0]?.cta_title || "",
      // BlogTextArea: removeHTML(nullToString(resArray[0]?.description)).replaceAll("\n", '').replaceAll(" ", '')
    };
    if (resArray?.[0]?.assets?.length > 0) {
      resArray[0]?.assets.forEach((ele) => {
        if (ele?.media === "image") {
          handleSelectedImage(ele, true);
        }

        if (ele?.media === "video") {
          handleSelectedVideo(ele, true);
        }
      });
    }
    if (resArray?.[0]?.item_path?.length > 0 && resArray[0]?.item_path[0]?.item_Details?.page) {
      const item = resArray[0]?.item_path[0]?.item_Details;
      const newObj = {
        background_content: item?.background_content || {},
        Thumbnail: {
          ...(typeof item?.Thumbnail === "string" ? {} : item?.Thumbnail),
          Title: item?.title,
          Description: item?.description,
          Url:
            buildCDNURL(
              item?.original_image?.original_image_relative_path ||
                (typeof item?.Thumbnail === "string" ? item?.Thumbnail : ""),
              item?.original_image?.ext,
            ) || defaultFallBackImage(),
        },
        ContentType: resArray?.[0]?.item_path?.[0]?.content_type,
        path: item?.page,
        EditorialItemPath: item?.page,
        PublishedDate: item?.publishedDate,
      };

      const secondaryArgs = {
        gcpUrl: authInfo.gcpUri,
      };

      const contentAdded = ReactDomServer.renderToString(
        <Box className='contentTypeBox'>
          <ContentTypeCard content={newObj} secondaryArgs={secondaryArgs}></ContentTypeCard>
        </Box>,
      );

      //is authors means empty image
      if (resArray?.[0]?.authors[0]) {
        newObj.Thumbnail = {};
      }
      handleContentType({
        contentItem: newObj,
        contentHtml: contentAdded,
      });
    }

    if (resArray[0]?.key_highlighter[0]?.time || resArray[0]?.key_highlighter[0]?.highlighter) {
      setIsStarOpen(true);
    } else {
      setIsStarOpen(false);
    }

    if (resArray[0]?.embeded[0]?.code) {
      setIsCodeOpen(true);
    } else {
      setIsCodeOpen(false);
    }

    if (resArray[0]?.authors[0]) {
      setIsQuoteOpen(true);
    } else {
      setIsQuoteOpen(false);
    }

    setBlogData(savedCustomerData);
    setSavedBlogData(resArray[0]);
    setSavedBlogId(resArray[0]?._id);
  };

  const handleEditContent = async (Id: any) => {
    const data = {
      id: Id,
    };
    try {
      setIsBlogLoad(true);
      const apiResponse = await fetchBlogByIdQuery({
        variables: {
          input: data,
        },
      });
      //remove exist image from image state
      setImageOrVideoToDefault();

      const { data: { authoring_fetchblogById: { response = {}, success = false } = {} } = {} } =
        apiResponse;

      if (success) {
        commonSaveData([{ ...response }]); //common
      }
    } catch (error: any) {
      const statusCode = error?.networkError?.statusCode || 0;
      if (error?.graphQLErrors?.length > 0) {
        showToastError(error?.graphQLErrors[0]?.message);
      } else {
        showToastError(t("api_error_toast"), statusCode);
      }
    } finally {
      setIsBlogLoad(false);
    }
  };

  /**
   * save data fetch
   */
  const fetchSavedBlogData = async () => {
    const data = {
      event_path: eventPath,
      is_published: false,
      is_soft_delete: false,
      start: 0,
      rows: rows,
      sortOrder: "desc",
      isSuggestive: false,
      pageSearch: "",
    };
    try {
      setIsBlogLoad(true);
      const apiResponse = await fetchBlogsQuery({
        variables: {
          input: data,
        },
      });
      const {
        data: {
          authoring_fetchblog: { response: { result = [] } = {}, success = false } = {},
        } = {},
      } = apiResponse;

      if (success && result?.length > 0) {
        commonSaveData(result); //common
      }
    } catch (error: any) {
      const statusCode = error?.networkError?.statusCode || 0;
      if (error?.graphQLErrors?.length > 0) {
        showToastError(error?.graphQLErrors[0]?.message);
      } else {
        showToastError(t("api_error_toast"), statusCode);
      }
    } finally {
      setIsBlogLoad(false);
    }
  };

  // Update Blog function
  const updateBlog = async () => {
    const mediaUrl = assetDescMake(selectedImage, selectedVideo, contentHtml);
    const updatedBlog = updatedBlogToSend({
      ...blogData,
      mediaUrl: mediaUrl,
      username: username,
      eventPath: eventPath,
      savedBlogId: savedBlogId,
      savedBlogData: savedBlogData,
      contentTypeData: [
        {
          content_type: contentItem?.ContentType,
          path: contentItem?.EditorialItemPath,
        },
      ],
      assetstosend: assetArrayMake(selectedImage, selectedVideo),
    });
    try {
      setIsBlogLoad(true);
      const apiResponse = await updateBlogMutate({
        variables: {
          input: updatedBlog,
        },
      });
      const { data: { authoring_updateblog: { success = false } = {} } = {} } = apiResponse;

      if (success) {
        setImageOrVideoToDefault(); //default image set
        ShowToastSuccess("Blog published successfully.");
        setApiCountCall(apiCountCall + 1); //fetch blog reload
        const emptyCustomerData = {
          BlogTitle: "",
          BlogEmbed: "",
          BlogTextArea: "",
          BlogKeyHighlighter: "",
          BlogAuthorName: "",
          BlogTimeStamp: "",
          cta_url: "",
          cta_title: "",
        };
        setBlogData(emptyCustomerData);
        setSavedBlogId("");
        setPublishButton(false);
      } else {
        showToastError(
          apiResponse?.data?.authoring_updateblog?.error?.message || t("api_error_toast"),
          apiResponse?.data?.authoring_updateblog?.error?.code || 0,
        );
      }
    } catch (error: any) {
      const statusCode = error?.networkError?.statusCode || 0;
      if (error?.graphQLErrors?.length > 0) {
        showToastError(error?.graphQLErrors[0]?.message);
      } else {
        showToastError(t("api_error_toast"), statusCode);
      }
    } finally {
      setIsBlogLoad(false);
    }
  };
  // Publish Blog function
  let embeddURLValue;
  let newValue;

  const publishBlog = async () => {
    //embed url validation//
    const iframeRegex = /^<iframe(.+)<\/iframe>/;
    if (
      (!blogData.BlogTitle ||
        !blogData.BlogTextArea ||
        !blogData.BlogTimeStamp ||
        blogData.BlogKeyHighlighter ||
        !blogData.BlogAuthorName) &&
      blogData.BlogEmbed
    ) {
      if (iframeRegex.test(blogData?.BlogEmbed)) {
        newValue = blogData?.BlogEmbed;
        const srcAttr = newValue.match(/src\s*=\s*"([^"]+)"/gm);
        if (srcAttr != null) {
          const embeddUrl = srcAttr[0]?.split('"')[1];
          embeddURLValue = embeddUrl;
          setBlogData({
            ...blogData,
            BlogTextArea: `${blogData?.BlogTextArea} ${blogData?.BlogEmbed}`,
          });
        }
      } else {
        showToastError("Please enter a valid Embed url");
        return false;
      }
    }
    const mediaUrl = assetDescMake(selectedImage, selectedVideo, contentHtml) || "";
    const descriptionData = !blogData?.BlogAuthorName
      ? `<span style="word-wrap: break-word" class="onlydesc">${
          blogData?.BlogTextArea + mediaUrl
        } </span>`
      : `<span style="word-wrap: break-word" class="onlydesc">${blogData?.BlogTextArea} </span>`;
    const data = {
      title: blogData?.BlogTitle,
      description: descriptionData,
      event_path: eventPath,
      is_published: true,
      is_soft_delete: false,
      created_date: new Date(),
      cta_url: blogData?.cta_url,
      cta_title: blogData?.cta_title,
      content_type: "Blog",
      page: eventPath,
      assets: assetArrayMake(selectedImage, selectedVideo),
      item_path: [
        {
          content_type: contentItem?.ContentType,
          path: contentItem?.EditorialItemPath,
        },
      ],
      embeded: [{ code: blogData?.BlogEmbed }],
      authors: blogData?.BlogAuthorName ? [blogData?.BlogAuthorName] : [],
      key_highlighter: [
        {
          highlighter: blogData?.BlogKeyHighlighter,
          time: blogData?.BlogTimeStamp,
        },
      ],
      created_by: username,
      last_published_date: new Date(),
      last_published_by: username,
      modified_date: new Date(),
      modified_by: username,
    };
    try {
      setIsBlogLoad(true);
      const apiResponse = await createBlogMutate({
        variables: {
          input: data,
        },
      });
      const { data: { authoring_createblog: { success = false } = {} } = {} } = apiResponse;
      if (success) {
        setImageOrVideoToDefault(); //default image set

        ShowToastSuccess("Blog published successfully.");
        setApiCountCall(apiCountCall + 1); //fetch blog reload
        const emptyCustomerData = {
          BlogTitle: "",
          BlogEmbed: "",
          BlogTextArea: "",
          BlogKeyHighlighter: "",
          BlogAuthorName: "",
          BlogTimeStamp: "",
          cta_url: "",
          cta_title: "",
        };
        setBlogData(emptyCustomerData);
        setIsBlogCreate(false);
        setPublishButton(false);
      } else {
        showToastError(
          apiResponse?.data?.authoring_updateblog?.error?.message || t("api_error_toast"),
          apiResponse?.data?.authoring_updateblog?.error?.code || 0,
        );
      }
    } catch (error: any) {
      const statusCode = error?.networkError?.statusCode || 0;
      if (error?.graphQLErrors?.length > 0) {
        showToastError(error?.graphQLErrors[0]?.message);
      } else {
        showToastError(t("api_error_toast"), statusCode);
      }
    } finally {
      setIsBlogLoad(false);
    }
  };
  // Save Blog function
  const saveButtonHandle = async () => {
    const mediaUrl = assetDescMake(selectedImage, selectedVideo, contentHtml) || "";

    const descriptionData = !blogData?.BlogAuthorName
      ? `<span style="word-wrap: break-word" class="onlydesc">${
          blogData?.BlogTextArea + mediaUrl
        } </span>`
      : `<span style="word-wrap: break-word" class="onlydesc">${blogData?.BlogTextArea} </span>`;
    const data = {
      title: blogData?.BlogTitle,
      description: descriptionData,
      event_path: eventPath,
      is_published: false,
      is_soft_delete: false,
      cta_url: blogData?.cta_url,
      cta_title: blogData?.cta_title,
      content_type: "Blog",
      page: eventPath,
      assets: assetArrayMake(selectedImage, selectedVideo),
      item_path: [
        {
          content_type: contentItem?.ContentType,
          path: contentItem?.EditorialItemPath,
        },
      ],
      embeded: [{ code: blogData?.BlogEmbed }],
      authors: blogData?.BlogAuthorName ? [blogData?.BlogAuthorName] : [],
      key_highlighter: [
        {
          highlighter: blogData?.BlogKeyHighlighter,
          time: blogData?.BlogTimeStamp,
        },
      ],
      created_date: new Date(),
      created_by: username,
      last_published_date: "",
      last_published_by: "",
      modified_date: new Date(),
      modified_by: username,
    };

    try {
      setIsBlogLoad(true);
      const apiResponse = await createBlogMutate({
        variables: {
          input: data,
        },
      });
      const { data: { authoring_createblog: { success = false } = {} } = {} } = apiResponse;

      if (success) {
        ShowToastSuccess("Blog saved successfully.");
      } else {
        showToastError(t("api_error_toast"));
      }
    } catch (error: any) {
      const statusCode = error?.networkError?.statusCode || 0;
      if (error?.graphQLErrors?.length > 0) {
        showToastError(error?.graphQLErrors[0]?.message);
      } else {
        showToastError(t("api_error_toast"), statusCode);
      }
    } finally {
      setIsBlogLoad(false);
    }
  };

  // Publish Button handel function
  const savePublishHandle = () => {
    setPublishButton(true);
    if (savedBlogId) {
      updateBlog();
    } else {
      publishBlog();
    }
  };

  const handleBack = () => {
    navigate("/content/event");
  };

  useEffect(() => {
    if (eventPath) {
      fetchSavedBlogData();
    }
  }, []);

  return (
    <>
      <style>{styles}</style>
      <Grid className='liveBlogger' container sx={{ backgroundColor: "#f5f6f8" }}>
        <Grid
          item
          xs={12}
          lg={12}
          sx={{
            backgroundColor: "#fff",
            borderRadius: "4px",
            padding: "10px 13px 10px 13px",
            display: "flex",
          }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              flex: "0%",
            }}>
            <IconButton
              aria-label='west'
              size='medium'
              onClick={handleBack}
              data-testid='timeline-blogs-back-btn'
              disableRipple
              disableFocusRipple>
              <KeyboardBackspaceRoundedIcon sx={{ color: theme.palette.customColor.PRIMARY }} />
            </IconButton>
            {!noWeb && <Typography variant='h4bold'>{t("write_a_Blog")}</Typography>}
          </Box>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{
          display: {
            xs: "block",
            md: "block",
            lg: "none",
            background: "#F5F6F8",
            paddingTop: "15px",
          },
        }}>
        <TabContext value={selectedTabvalue}>
          <BlogHeaderTabMobileView handleTabChange={handleTabChange} />

          <Grid container className='test-tab' sx={{ display: { xs: "unset" } }}>
            <TabPanel
              value='3'
              className='platx-tab-event-section'
              sx={{
                overflowY: "auto",
                overflowX: "hidden",
                height: "calc(100vh - 180px)",
                padding: "0px 14px",
              }}>
              <Grid item xs={12} sx={{ borderRadius: "4px" }} className='platx-event'>
                <BlogEvents eventPath={eventPath} />
              </Grid>
            </TabPanel>

            <TabPanel
              value='1'
              className='platx-tab-blog-section'
              style={{ padding: "14px 0 !important" }}
              sx={{
                overflowY: "auto",
                overflowX: "hidden",
                height: "calc(100vh - 180px)",
                paddingTop: "0px",
              }}>
              <Grid item xs={12} className='platx-blog'>
                {/* mobile view */}
                <Blogs
                  onRemoveImage={onRemoveImage}
                  onRemoveVideo={onRemoveVideo}
                  selectedImage={selectedImage}
                  selectedVideo={selectedVideo}
                  quoteClickHandel={quoteClickHandel}
                  starClickHandel={starClickHandel}
                  handleBlogChange={handleBlogChange}
                  blogData={blogData}
                  setBlogData={setBlogData}
                  saveButtonHandle={saveButtonHandle}
                  savePublishHandle={savePublishHandle}
                  isBlogLoad={isBlogLoad}
                  handleSelectedImage={handleSelectedImage}
                  handleSelectedVideo={handleSelectedVideo}
                  handleContentType={handleContentType}
                  isCodeOpen={isCodeOpen}
                  isQuoteOpen={isQuoteOpen}
                  isStarOpen={isStarOpen}
                  publishButton={publishButton}
                  linkClickHandle={linkClickHandle}
                  isLinkOpen={isLinkOpen}
                  galleryState={galleryState}
                  setGalleryState={setGalleryState}
                />
              </Grid>
            </TabPanel>
            <TabPanel
              value='2'
              className='platx-tab-timeline-section'
              sx={{
                overflowY: "auto",
                overflowX: "hidden",
                height: "calc(100vh - 180px)",
                paddingTop: "0px 14px",
              }}>
              <Grid
                item
                xs={12}
                sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                className='platx-blog-timeline'>
                <BlogTimeline
                  eventPath={eventPath}
                  isBlogLoad={isBlogCreate}
                  apiCountCall={apiCountCall}
                  handleEdit={handleEditContent}
                  embeddURLValue={embeddURLValue}
                  className='platx-blog-timeline-wrapper'
                />
              </Grid>
            </TabPanel>
          </Grid>
        </TabContext>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: "#f5f6f8",
          p: 2,
          display: { xs: "none", sm: "none", em: "none", lg: "flex" },
        }}>
        <Grid
          item
          xs={12}
          lg={3}
          sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
          className='platx-event'>
          <BlogEvents eventPath={eventPath} />
        </Grid>

        {/* web view */}
        <Grid item xs={12} lg={5} className='platx-blog'>
          <Blogs
            contentItem={contentItem}
            onRemoveContentType={onRemoveContentType}
            onRemoveImage={onRemoveImage}
            onRemoveVideo={onRemoveVideo}
            selectedImage={selectedImage}
            selectedVideo={selectedVideo}
            quoteClickHandel={quoteClickHandel}
            starClickHandel={starClickHandel}
            handleBlogChange={handleBlogChange}
            blogData={blogData}
            setBlogData={setBlogData}
            saveButtonHandle={saveButtonHandle}
            savePublishHandle={savePublishHandle}
            isBlogLoad={isBlogLoad}
            handleSelectedImage={handleSelectedImage}
            handleSelectedVideo={handleSelectedVideo}
            handleContentType={handleContentType}
            isCodeOpen={isCodeOpen}
            isQuoteOpen={isQuoteOpen}
            isStarOpen={isStarOpen}
            publishButton={publishButton}
            linkClickHandle={linkClickHandle}
            isLinkOpen={isLinkOpen}
            galleryState={galleryState}
            setGalleryState={setGalleryState}
          />
        </Grid>
        <Grid
          item
          xs={12}
          lg={4}
          sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
          className='platx-blog-timeline'>
          <BlogTimeline
            isBlogLoad={isBlogCreate}
            handleEdit={handleEditContent}
            embeddURLValue={embeddURLValue}
            eventPath={eventPath}
            apiCountCall={apiCountCall}
          />
        </Grid>
      </Grid>
    </>
  );
};
export default memo(TimeLineBlogs);
